import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A 64-bit signed integer */
  Long: { input: any; output: any; }
};

export type Activity = {
  __typename?: 'Activity';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Architecture = {
  __typename?: 'Architecture';
  id?: Maybe<Scalars['Long']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type BusinessDirection = {
  __typename?: 'BusinessDirection';
  businessUnitId?: Maybe<Scalars['ID']['output']>;
  canton?: Maybe<Canton>;
  intersection?: Maybe<Scalars['String']['output']>;
  storeName?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['Int']['output']>;
};

export type BusinessDirectionIn = {
  businessUnitId: Scalars['Long']['input'];
  canton: CantonIn;
  intersection: Scalars['String']['input'];
  storeName: Scalars['String']['input'];
  street: Scalars['String']['input'];
  streetNumber: Scalars['Int']['input'];
};

export type BusinessDirectionUp = {
  businessUnitId?: InputMaybe<Scalars['ID']['input']>;
  canton?: InputMaybe<CantonUp>;
  intersection?: InputMaybe<Scalars['String']['input']>;
  storeName?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  streetNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type BusinessUnit = {
  __typename?: 'BusinessUnit';
  active?: Maybe<Scalars['Boolean']['output']>;
  branchOfficeId?: Maybe<Scalars['Long']['output']>;
  businessDirection?: Maybe<BusinessDirection>;
  id?: Maybe<Scalars['ID']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
};

export type BusinessUnitIn = {
  active: Scalars['Boolean']['input'];
  branchOfficeId: Scalars['Long']['input'];
  businessDirection?: InputMaybe<BusinessDirectionIn>;
  id: Scalars['ID']['input'];
};

export type BusinessUnitUp = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  branchOfficeId?: InputMaybe<Scalars['ID']['input']>;
  businessDirection?: InputMaybe<BusinessDirectionUp>;
  id: Scalars['ID']['input'];
};

export type Canton = {
  __typename?: 'Canton';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provinceId?: Maybe<Scalars['ID']['output']>;
};

export type CantonIn = {
  id: Scalars['ID']['input'];
  provinceId: Scalars['ID']['input'];
};

export type CantonUp = {
  id?: InputMaybe<Scalars['ID']['input']>;
  provinceId?: InputMaybe<Scalars['ID']['input']>;
};

export type CashRegister = {
  __typename?: 'CashRegister';
  active?: Maybe<Scalars['Boolean']['output']>;
  activity?: Maybe<Activity>;
  businessUnitId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  sriEnvironment?: Maybe<SriEnvironment>;
  type?: Maybe<CashRegisterType>;
  user?: Maybe<CashRegisterUser>;
};

export type CashRegisterIn = {
  active: Scalars['Boolean']['input'];
  activity: IdIn;
  businessUnitId: Scalars['Long']['input'];
  id: Scalars['Long']['input'];
  name: Scalars['String']['input'];
  sriEnvironment: IdIn;
  type: IdIn;
  user: IdIn;
};

export type CashRegisterType = {
  __typename?: 'CashRegisterType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CashRegisterUp = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  activity?: InputMaybe<IdIn>;
  businessUnitId?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['Long']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sriEnvironment?: InputMaybe<IdIn>;
  type?: InputMaybe<IdIn>;
  user?: InputMaybe<IdIn>;
};

export type CashRegisterUser = {
  __typename?: 'CashRegisterUser';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EconomicNature = {
  __typename?: 'EconomicNature';
  architecture?: Maybe<Architecture>;
  banking?: Maybe<Scalars['Int']['output']>;
  businessUnitId?: Maybe<Scalars['ID']['output']>;
  prototype?: Maybe<Prototype>;
  sector?: Maybe<Sector>;
};

export type EconomicNatureIn = {
  architecture: IdIn;
  banking: Scalars['Int']['input'];
  businessUnitId: Scalars['Long']['input'];
  prototype: IdIn;
  sector: IdIn;
};

export type GenericNumber = {
  __typename?: 'GenericNumber';
  number?: Maybe<Scalars['Int']['output']>;
};

export type IdDto = {
  __typename?: 'IdDTO';
  id?: Maybe<Scalars['ID']['output']>;
};

export type IdIn = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  deleteCashRegister?: Maybe<Scalars['Boolean']['output']>;
  deleteWarehouse?: Maybe<Scalars['Boolean']['output']>;
  saveBusinessDirection?: Maybe<IdDto>;
  saveBusinessUnit?: Maybe<IdDto>;
  saveCashRegister?: Maybe<IdDto>;
  saveEconomicNature?: Maybe<IdDto>;
  saveWarehouse?: Maybe<IdDto>;
  updateBusinessUnit?: Maybe<IdDto>;
  updateCashRegister?: Maybe<IdDto>;
  updateWarehouse?: Maybe<IdDto>;
};


export type MutationDeleteCashRegisterArgs = {
  cashRegisterId: Scalars['ID']['input'];
};


export type MutationDeleteWarehouseArgs = {
  warehouseId: Scalars['ID']['input'];
};


export type MutationSaveBusinessDirectionArgs = {
  dto: BusinessDirectionIn;
};


export type MutationSaveBusinessUnitArgs = {
  dto: BusinessUnitIn;
};


export type MutationSaveCashRegisterArgs = {
  dto: CashRegisterIn;
};


export type MutationSaveEconomicNatureArgs = {
  dto: EconomicNatureIn;
};


export type MutationSaveWarehouseArgs = {
  dto: WarehouseIn;
};


export type MutationUpdateBusinessUnitArgs = {
  dto: BusinessUnitUp;
};


export type MutationUpdateCashRegisterArgs = {
  dto: CashRegisterUp;
};


export type MutationUpdateWarehouseArgs = {
  dto: WarehouseUp;
};

export type Number = {
  __typename?: 'Number';
  cashRegisterNumber?: Maybe<Scalars['Int']['output']>;
};

export type Prototype = {
  __typename?: 'Prototype';
  id?: Maybe<Scalars['Long']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Province = {
  __typename?: 'Province';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  getAllCashRegSriEnv?: Maybe<Array<Maybe<SriEnvironment>>>;
  getAllCashRegType?: Maybe<Array<Maybe<CashRegisterType>>>;
  getAllWarehouseType?: Maybe<Array<Maybe<WarehouseType>>>;
  getArchitecture?: Maybe<Array<Maybe<Architecture>>>;
  getBusinessDirectionById?: Maybe<BusinessDirection>;
  getBusinessUnitById?: Maybe<BusinessUnit>;
  getByBranchOfficeId?: Maybe<Array<Maybe<BusinessUnit>>>;
  getCantonsById?: Maybe<Array<Maybe<Canton>>>;
  getCashRegisterByBusinessUnitId?: Maybe<Array<Maybe<CashRegister>>>;
  getCashRegisterById?: Maybe<CashRegister>;
  getEconomicNatureById?: Maybe<EconomicNature>;
  getNextCashRegisterNumber?: Maybe<GenericNumber>;
  getNextWarehouseNumber?: Maybe<GenericNumber>;
  getPrototype?: Maybe<Array<Maybe<Prototype>>>;
  getProvinces?: Maybe<Array<Maybe<Province>>>;
  getSector?: Maybe<Array<Maybe<Sector>>>;
  getWarehouseByBusinessUnitId?: Maybe<Array<Maybe<Warehouse>>>;
  getWarehouseById?: Maybe<Warehouse>;
};


export type QueryGetBusinessDirectionByIdArgs = {
  businessUnitId: Scalars['ID']['input'];
};


export type QueryGetBusinessUnitByIdArgs = {
  businessUnitId: Scalars['ID']['input'];
};


export type QueryGetByBranchOfficeIdArgs = {
  branchOfficeId: Scalars['ID']['input'];
};


export type QueryGetCantonsByIdArgs = {
  provinceId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetCashRegisterByBusinessUnitIdArgs = {
  businessUnitId: Scalars['ID']['input'];
};


export type QueryGetCashRegisterByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEconomicNatureByIdArgs = {
  businessUnitId: Scalars['ID']['input'];
};


export type QueryGetNextCashRegisterNumberArgs = {
  businessUnitId: Scalars['ID']['input'];
};


export type QueryGetNextWarehouseNumberArgs = {
  businessUnitId: Scalars['ID']['input'];
};


export type QueryGetWarehouseByBusinessUnitIdArgs = {
  businessUnitId: Scalars['ID']['input'];
};


export type QueryGetWarehouseByIdArgs = {
  id: Scalars['ID']['input'];
};

export type Sector = {
  __typename?: 'Sector';
  id?: Maybe<Scalars['Long']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SriEnvironment = {
  __typename?: 'SriEnvironment';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Warehouse = {
  __typename?: 'Warehouse';
  active?: Maybe<Scalars['Boolean']['output']>;
  businessUnitId?: Maybe<Scalars['Long']['output']>;
  creationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<WarehouseType>;
  user?: Maybe<WarehouseUser>;
};

export type WarehouseIn = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  businessUnitId?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IdIn>;
  user?: InputMaybe<IdIn>;
};

export type WarehouseType = {
  __typename?: 'WarehouseType';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type WarehouseUp = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  businessUnitId?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<IdIn>;
  user?: InputMaybe<IdIn>;
};

export type WarehouseUser = {
  __typename?: 'WarehouseUser';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type SaveBusinessUnitMutationVariables = Exact<{
  json: BusinessUnitIn;
}>;


export type SaveBusinessUnitMutation = { __typename?: 'Mutation', saveBusinessUnit?: { __typename?: 'IdDTO', id?: string | null } | null };

export type SaveBusinessDirectionMutationVariables = Exact<{
  json: BusinessDirectionIn;
}>;


export type SaveBusinessDirectionMutation = { __typename?: 'Mutation', saveBusinessDirection?: { __typename?: 'IdDTO', id?: string | null } | null };

export type SaveEconomicNatureMutationVariables = Exact<{
  json: EconomicNatureIn;
}>;


export type SaveEconomicNatureMutation = { __typename?: 'Mutation', saveEconomicNature?: { __typename?: 'IdDTO', id?: string | null } | null };

export type UpdateBusinessUnitMutationVariables = Exact<{
  json: BusinessUnitUp;
}>;


export type UpdateBusinessUnitMutation = { __typename?: 'Mutation', updateBusinessUnit?: { __typename?: 'IdDTO', id?: string | null } | null };

export type UpdateBusinessUnitActiveMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateBusinessUnitActiveMutation = { __typename?: 'Mutation', updateBusinessUnit?: { __typename?: 'IdDTO', id?: string | null } | null };

export type GetBusinessUnitQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBusinessUnitQuery = { __typename?: 'Query', getByBranchOfficeId?: Array<{ __typename?: 'BusinessUnit', id?: string | null, active?: boolean | null, businessDirection?: { __typename?: 'BusinessDirection', storeName?: string | null, canton?: { __typename?: 'Canton', id?: string | null, name?: string | null, provinceId?: string | null } | null } | null } | null> | null };

export type GetBusinessUnitSummaryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBusinessUnitSummaryQuery = { __typename?: 'Query', getByBranchOfficeId?: Array<{ __typename?: 'BusinessUnit', id?: string | null, number?: number | null, active?: boolean | null, businessDirection?: { __typename?: 'BusinessDirection', storeName?: string | null, canton?: { __typename?: 'Canton', name?: string | null } | null } | null } | null> | null };

export type GetBusinessDirectionByIdQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetBusinessDirectionByIdQuery = { __typename?: 'Query', getBusinessDirectionById?: { __typename?: 'BusinessDirection', street?: string | null, streetNumber?: number | null, storeName?: string | null, intersection?: string | null, canton?: { __typename?: 'Canton', id?: string | null, name?: string | null, provinceId?: string | null } | null } | null };

export type GetEconomicNatureByIdQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetEconomicNatureByIdQuery = { __typename?: 'Query', getEconomicNatureById?: { __typename?: 'EconomicNature', businessUnitId?: string | null, banking?: number | null, architecture?: { __typename?: 'Architecture', id?: any | null, name?: string | null } | null, prototype?: { __typename?: 'Prototype', id?: any | null, name?: string | null } | null, sector?: { __typename?: 'Sector', id?: any | null, name?: string | null } | null } | null };

export type GetAllBusinessEntitiesIdQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetAllBusinessEntitiesIdQuery = { __typename?: 'Query', getBusinessDirectionById?: { __typename?: 'BusinessDirection', businessUnitId?: string | null } | null, getEconomicNatureById?: { __typename?: 'EconomicNature', businessUnitId?: string | null } | null, getCashRegisterByBusinessUnitId?: Array<{ __typename?: 'CashRegister', businessUnitId?: any | null } | null> | null, getWarehouseByBusinessUnitId?: Array<{ __typename?: 'Warehouse', businessUnitId?: any | null } | null> | null };

export type GetEconomicNatureCatalogsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEconomicNatureCatalogsQuery = { __typename?: 'Query', getPrototype?: Array<{ __typename?: 'Prototype', id?: any | null, name?: string | null } | null> | null, getSector?: Array<{ __typename?: 'Sector', id?: any | null, name?: string | null } | null> | null, getArchitecture?: Array<{ __typename?: 'Architecture', id?: any | null, name?: string | null } | null> | null };

export type GetProvincesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProvincesQuery = { __typename?: 'Query', getProvinces?: Array<{ __typename?: 'Province', id?: string | null, name?: string | null } | null> | null };

export type GetCantonesByIdQueryVariables = Exact<{
  provinceId: Scalars['ID']['input'];
}>;


export type GetCantonesByIdQuery = { __typename?: 'Query', getCantonsById?: Array<{ __typename?: 'Canton', id?: string | null, name?: string | null, provinceId?: string | null } | null> | null };

export type SaveCashRegisterMutationVariables = Exact<{
  json: CashRegisterIn;
}>;


export type SaveCashRegisterMutation = { __typename?: 'Mutation', saveCashRegister?: { __typename?: 'IdDTO', id?: string | null } | null };

export type UpdateCashRegisterMutationVariables = Exact<{
  json: CashRegisterUp;
}>;


export type UpdateCashRegisterMutation = { __typename?: 'Mutation', updateCashRegister?: { __typename?: 'IdDTO', id?: string | null } | null };

export type DeleteCashRegisterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCashRegisterMutation = { __typename?: 'Mutation', deleteCashRegister?: boolean | null };

export type GetCashRegisterByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCashRegisterByIdQuery = { __typename?: 'Query', getCashRegisterById?: { __typename?: 'CashRegister', id?: string | null, businessUnitId?: any | null, name?: string | null, number?: number | null, active?: boolean | null, creationDate?: string | null, type?: { __typename?: 'CashRegisterType', id?: string | null, name?: string | null } | null, sriEnvironment?: { __typename?: 'SriEnvironment', id?: string | null, name?: string | null } | null, activity?: { __typename?: 'Activity', id?: string | null, description?: string | null } | null, user?: { __typename?: 'CashRegisterUser', id?: string | null, name?: string | null } | null } | null };

export type GetCashRegisterByBusinessUnitIdQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetCashRegisterByBusinessUnitIdQuery = { __typename?: 'Query', getCashRegisterByBusinessUnitId?: Array<{ __typename?: 'CashRegister', id?: string | null, businessUnitId?: any | null, name?: string | null, number?: number | null, active?: boolean | null, creationDate?: string | null, type?: { __typename?: 'CashRegisterType', id?: string | null, name?: string | null } | null, activity?: { __typename?: 'Activity', id?: string | null, description?: string | null } | null } | null> | null };

export type GetCashRegisterByIdToPointEmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCashRegisterByIdToPointEmissionQuery = { __typename?: 'Query', getCashRegisterById?: { __typename?: 'CashRegister', id?: string | null, businessUnitId?: any | null, name?: string | null, active?: boolean | null, creationDate?: string | null, sriEnvironment?: { __typename?: 'SriEnvironment', id?: string | null, name?: string | null } | null, user?: { __typename?: 'CashRegisterUser', id?: string | null, name?: string | null } | null } | null };

export type GetCashRegisterToPointEmissionQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetCashRegisterToPointEmissionQuery = { __typename?: 'Query', getCashRegisterByBusinessUnitId?: Array<{ __typename?: 'CashRegister', id?: string | null, businessUnitId?: any | null, name?: string | null, number?: number | null, active?: boolean | null, creationDate?: string | null, sriEnvironment?: { __typename?: 'SriEnvironment', id?: string | null, name?: string | null } | null, user?: { __typename?: 'CashRegisterUser', id?: string | null, name?: string | null } | null } | null> | null };

export type GetNextCashRegisterNumberQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetNextCashRegisterNumberQuery = { __typename?: 'Query', getNextCashRegisterNumber?: { __typename?: 'GenericNumber', number?: number | null } | null };

export type GetCashRegisterCatalogsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCashRegisterCatalogsQuery = { __typename?: 'Query', getAllCashRegSriEnv?: Array<{ __typename?: 'SriEnvironment', id?: string | null, name?: string | null } | null> | null, getAllCashRegType?: Array<{ __typename?: 'CashRegisterType', id?: string | null, name?: string | null } | null> | null };

export type SaveWarehouseMutationVariables = Exact<{
  json: WarehouseIn;
}>;


export type SaveWarehouseMutation = { __typename?: 'Mutation', saveWarehouse?: { __typename?: 'IdDTO', id?: string | null } | null };

export type UpdateWarehouseMutationVariables = Exact<{
  json: WarehouseUp;
}>;


export type UpdateWarehouseMutation = { __typename?: 'Mutation', updateWarehouse?: { __typename?: 'IdDTO', id?: string | null } | null };

export type DeleteWarehouseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWarehouseMutation = { __typename?: 'Mutation', deleteWarehouse?: boolean | null };

export type GetWarehouseByBusinessUnitIdQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetWarehouseByBusinessUnitIdQuery = { __typename?: 'Query', getWarehouseByBusinessUnitId?: Array<{ __typename?: 'Warehouse', active?: boolean | null, businessUnitId?: any | null, creationDate?: string | null, id?: string | null, name?: string | null, number?: number | null, type?: { __typename?: 'WarehouseType', id?: string | null, name?: string | null, shortName?: string | null } | null, user?: { __typename?: 'WarehouseUser', id?: string | null } | null } | null> | null };

export type GetWarehouseByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWarehouseByIdQuery = { __typename?: 'Query', getWarehouseById?: { __typename?: 'Warehouse', active?: boolean | null, businessUnitId?: any | null, creationDate?: string | null, id?: string | null, name?: string | null, number?: number | null, user?: { __typename?: 'WarehouseUser', id?: string | null } | null, type?: { __typename?: 'WarehouseType', id?: string | null, shortName?: string | null } | null } | null };

export type GetAllSummaryWarehouseQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetAllSummaryWarehouseQuery = { __typename?: 'Query', getWarehouseByBusinessUnitId?: Array<{ __typename?: 'Warehouse', id?: string | null, businessUnitId?: any | null, active?: boolean | null, name?: string | null, number?: number | null, creationDate?: string | null, type?: { __typename?: 'WarehouseType', id?: string | null, name?: string | null, shortName?: string | null } | null, user?: { __typename?: 'WarehouseUser', id?: string | null, name?: string | null } | null } | null> | null };

export type GetNextWarehouseNumberQueryVariables = Exact<{
  businessUnitId: Scalars['ID']['input'];
}>;


export type GetNextWarehouseNumberQuery = { __typename?: 'Query', getNextWarehouseNumber?: { __typename?: 'GenericNumber', number?: number | null } | null };

export type GetAllWarehouseTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllWarehouseTypeQuery = { __typename?: 'Query', getAllWarehouseType?: Array<{ __typename?: 'WarehouseType', id?: string | null, name?: string | null, shortName?: string | null } | null> | null };

export const SaveBusinessUnitDocument = gql`
    mutation SaveBusinessUnit($json: BusinessUnitIn!) {
  saveBusinessUnit(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBusinessUnitGQL extends Apollo.Mutation<SaveBusinessUnitMutation, SaveBusinessUnitMutationVariables> {
    override document = SaveBusinessUnitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBusinessDirectionDocument = gql`
    mutation SaveBusinessDirection($json: BusinessDirectionIn!) {
  saveBusinessDirection(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBusinessDirectionGQL extends Apollo.Mutation<SaveBusinessDirectionMutation, SaveBusinessDirectionMutationVariables> {
    override document = SaveBusinessDirectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveEconomicNatureDocument = gql`
    mutation SaveEconomicNature($json: EconomicNatureIn!) {
  saveEconomicNature(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveEconomicNatureGQL extends Apollo.Mutation<SaveEconomicNatureMutation, SaveEconomicNatureMutationVariables> {
    override document = SaveEconomicNatureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBusinessUnitDocument = gql`
    mutation UpdateBusinessUnit($json: BusinessUnitUp!) {
  updateBusinessUnit(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBusinessUnitGQL extends Apollo.Mutation<UpdateBusinessUnitMutation, UpdateBusinessUnitMutationVariables> {
    override document = UpdateBusinessUnitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBusinessUnitActiveDocument = gql`
    mutation UpdateBusinessUnitActive($id: ID!, $active: Boolean) {
  updateBusinessUnit(dto: {id: $id, active: $active}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBusinessUnitActiveGQL extends Apollo.Mutation<UpdateBusinessUnitActiveMutation, UpdateBusinessUnitActiveMutationVariables> {
    override document = UpdateBusinessUnitActiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessUnitDocument = gql`
    query GetBusinessUnit($id: ID!) {
  getByBranchOfficeId(branchOfficeId: $id) {
    id
    active
    businessDirection {
      canton {
        id
        name
        provinceId
      }
      storeName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessUnitGQL extends Apollo.Query<GetBusinessUnitQuery, GetBusinessUnitQueryVariables> {
    override document = GetBusinessUnitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessUnitSummaryDocument = gql`
    query GetBusinessUnitSummary($id: ID!) {
  getByBranchOfficeId(branchOfficeId: $id) {
    id
    number
    active
    businessDirection {
      canton {
        name
      }
      storeName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessUnitSummaryGQL extends Apollo.Query<GetBusinessUnitSummaryQuery, GetBusinessUnitSummaryQueryVariables> {
    override document = GetBusinessUnitSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBusinessDirectionByIdDocument = gql`
    query GetBusinessDirectionById($businessUnitId: ID!) {
  getBusinessDirectionById(businessUnitId: $businessUnitId) {
    canton {
      id
      name
      provinceId
    }
    street
    streetNumber
    storeName
    intersection
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessDirectionByIdGQL extends Apollo.Query<GetBusinessDirectionByIdQuery, GetBusinessDirectionByIdQueryVariables> {
    override document = GetBusinessDirectionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEconomicNatureByIdDocument = gql`
    query GetEconomicNatureById($businessUnitId: ID!) {
  getEconomicNatureById(businessUnitId: $businessUnitId) {
    businessUnitId
    architecture {
      id
      name
    }
    prototype {
      id
      name
    }
    sector {
      id
      name
    }
    banking
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEconomicNatureByIdGQL extends Apollo.Query<GetEconomicNatureByIdQuery, GetEconomicNatureByIdQueryVariables> {
    override document = GetEconomicNatureByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllBusinessEntitiesIdDocument = gql`
    query GetAllBusinessEntitiesId($businessUnitId: ID!) {
  getBusinessDirectionById(businessUnitId: $businessUnitId) {
    businessUnitId
  }
  getEconomicNatureById(businessUnitId: $businessUnitId) {
    businessUnitId
  }
  getCashRegisterByBusinessUnitId(businessUnitId: $businessUnitId) {
    businessUnitId
  }
  getWarehouseByBusinessUnitId(businessUnitId: $businessUnitId) {
    businessUnitId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllBusinessEntitiesIdGQL extends Apollo.Query<GetAllBusinessEntitiesIdQuery, GetAllBusinessEntitiesIdQueryVariables> {
    override document = GetAllBusinessEntitiesIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEconomicNatureCatalogsDocument = gql`
    query GetEconomicNatureCatalogs {
  getPrototype {
    id
    name
  }
  getSector {
    id
    name
  }
  getArchitecture {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEconomicNatureCatalogsGQL extends Apollo.Query<GetEconomicNatureCatalogsQuery, GetEconomicNatureCatalogsQueryVariables> {
    override document = GetEconomicNatureCatalogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetProvincesDocument = gql`
    query GetProvinces {
  getProvinces {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProvincesGQL extends Apollo.Query<GetProvincesQuery, GetProvincesQueryVariables> {
    override document = GetProvincesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCantonesByIdDocument = gql`
    query GetCantonesById($provinceId: ID!) {
  getCantonsById(provinceId: $provinceId) {
    id
    name
    provinceId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCantonesByIdGQL extends Apollo.Query<GetCantonesByIdQuery, GetCantonesByIdQueryVariables> {
    override document = GetCantonesByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCashRegisterDocument = gql`
    mutation SaveCashRegister($json: CashRegisterIn!) {
  saveCashRegister(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCashRegisterGQL extends Apollo.Mutation<SaveCashRegisterMutation, SaveCashRegisterMutationVariables> {
    override document = SaveCashRegisterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCashRegisterDocument = gql`
    mutation UpdateCashRegister($json: CashRegisterUp!) {
  updateCashRegister(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCashRegisterGQL extends Apollo.Mutation<UpdateCashRegisterMutation, UpdateCashRegisterMutationVariables> {
    override document = UpdateCashRegisterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCashRegisterDocument = gql`
    mutation DeleteCashRegister($id: ID!) {
  deleteCashRegister(cashRegisterId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCashRegisterGQL extends Apollo.Mutation<DeleteCashRegisterMutation, DeleteCashRegisterMutationVariables> {
    override document = DeleteCashRegisterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCashRegisterByIdDocument = gql`
    query GetCashRegisterById($id: ID!) {
  getCashRegisterById(id: $id) {
    id
    businessUnitId
    name
    number
    type {
      id
      name
    }
    sriEnvironment {
      id
      name
    }
    activity {
      id
      description
    }
    user {
      id
      name
    }
    active
    creationDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCashRegisterByIdGQL extends Apollo.Query<GetCashRegisterByIdQuery, GetCashRegisterByIdQueryVariables> {
    override document = GetCashRegisterByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCashRegisterByBusinessUnitIdDocument = gql`
    query GetCashRegisterByBusinessUnitId($businessUnitId: ID!) {
  getCashRegisterByBusinessUnitId(businessUnitId: $businessUnitId) {
    id
    businessUnitId
    name
    number
    type {
      id
      name
    }
    activity {
      id
      description
    }
    active
    creationDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCashRegisterByBusinessUnitIdGQL extends Apollo.Query<GetCashRegisterByBusinessUnitIdQuery, GetCashRegisterByBusinessUnitIdQueryVariables> {
    override document = GetCashRegisterByBusinessUnitIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCashRegisterByIdToPointEmissionDocument = gql`
    query GetCashRegisterByIdToPointEmission($id: ID!) {
  getCashRegisterById(id: $id) {
    id
    businessUnitId
    sriEnvironment {
      id
      name
    }
    name
    user {
      id
      name
    }
    active
    creationDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCashRegisterByIdToPointEmissionGQL extends Apollo.Query<GetCashRegisterByIdToPointEmissionQuery, GetCashRegisterByIdToPointEmissionQueryVariables> {
    override document = GetCashRegisterByIdToPointEmissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCashRegisterToPointEmissionDocument = gql`
    query GetCashRegisterToPointEmission($businessUnitId: ID!) {
  getCashRegisterByBusinessUnitId(businessUnitId: $businessUnitId) {
    id
    businessUnitId
    sriEnvironment {
      id
      name
    }
    name
    number
    user {
      id
      name
    }
    active
    creationDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCashRegisterToPointEmissionGQL extends Apollo.Query<GetCashRegisterToPointEmissionQuery, GetCashRegisterToPointEmissionQueryVariables> {
    override document = GetCashRegisterToPointEmissionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNextCashRegisterNumberDocument = gql`
    query GetNextCashRegisterNumber($businessUnitId: ID!) {
  getNextCashRegisterNumber(businessUnitId: $businessUnitId) {
    number
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNextCashRegisterNumberGQL extends Apollo.Query<GetNextCashRegisterNumberQuery, GetNextCashRegisterNumberQueryVariables> {
    override document = GetNextCashRegisterNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCashRegisterCatalogsDocument = gql`
    query GetCashRegisterCatalogs {
  getAllCashRegSriEnv {
    id
    name
  }
  getAllCashRegType {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCashRegisterCatalogsGQL extends Apollo.Query<GetCashRegisterCatalogsQuery, GetCashRegisterCatalogsQueryVariables> {
    override document = GetCashRegisterCatalogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveWarehouseDocument = gql`
    mutation SaveWarehouse($json: WarehouseIn!) {
  saveWarehouse(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveWarehouseGQL extends Apollo.Mutation<SaveWarehouseMutation, SaveWarehouseMutationVariables> {
    override document = SaveWarehouseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateWarehouseDocument = gql`
    mutation UpdateWarehouse($json: WarehouseUp!) {
  updateWarehouse(dto: $json) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateWarehouseGQL extends Apollo.Mutation<UpdateWarehouseMutation, UpdateWarehouseMutationVariables> {
    override document = UpdateWarehouseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteWarehouseDocument = gql`
    mutation DeleteWarehouse($id: ID!) {
  deleteWarehouse(warehouseId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteWarehouseGQL extends Apollo.Mutation<DeleteWarehouseMutation, DeleteWarehouseMutationVariables> {
    override document = DeleteWarehouseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWarehouseByBusinessUnitIdDocument = gql`
    query GetWarehouseByBusinessUnitId($businessUnitId: ID!) {
  getWarehouseByBusinessUnitId(businessUnitId: $businessUnitId) {
    active
    businessUnitId
    creationDate
    id
    name
    number
    type {
      id
      name
      shortName
    }
    user {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWarehouseByBusinessUnitIdGQL extends Apollo.Query<GetWarehouseByBusinessUnitIdQuery, GetWarehouseByBusinessUnitIdQueryVariables> {
    override document = GetWarehouseByBusinessUnitIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWarehouseByIdDocument = gql`
    query GetWarehouseById($id: ID!) {
  getWarehouseById(id: $id) {
    active
    businessUnitId
    creationDate
    id
    name
    number
    user {
      id
    }
    type {
      id
      shortName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWarehouseByIdGQL extends Apollo.Query<GetWarehouseByIdQuery, GetWarehouseByIdQueryVariables> {
    override document = GetWarehouseByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSummaryWarehouseDocument = gql`
    query GetAllSummaryWarehouse($businessUnitId: ID!) {
  getWarehouseByBusinessUnitId(businessUnitId: $businessUnitId) {
    id
    businessUnitId
    active
    name
    number
    type {
      id
      name
      shortName
    }
    user {
      id
      name
    }
    creationDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSummaryWarehouseGQL extends Apollo.Query<GetAllSummaryWarehouseQuery, GetAllSummaryWarehouseQueryVariables> {
    override document = GetAllSummaryWarehouseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNextWarehouseNumberDocument = gql`
    query GetNextWarehouseNumber($businessUnitId: ID!) {
  getNextWarehouseNumber(businessUnitId: $businessUnitId) {
    number
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNextWarehouseNumberGQL extends Apollo.Query<GetNextWarehouseNumberQuery, GetNextWarehouseNumberQueryVariables> {
    override document = GetNextWarehouseNumberDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllWarehouseTypeDocument = gql`
    query GetAllWarehouseType {
  getAllWarehouseType {
    id
    name
    shortName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllWarehouseTypeGQL extends Apollo.Query<GetAllWarehouseTypeQuery, GetAllWarehouseTypeQueryVariables> {
    override document = GetAllWarehouseTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }